import React, {useState, useEffect} from 'react'
import {apiMy, apiUsersAdd} from "api-methods"
import {formatPhoneNumber} from "helper-func"
import Header from "../components/Header"
import BreadCrumbs from "../components/BreadCrumbs"
import CustomSelect from "../components/CustomSelect"
import Notification from "../components/Notification"
import '../css/EditCompany.css'
import {Loaders} from "../components/Loaders"
import {useNavigate} from "react-router-dom"

const UserAdd = () => {

    function isValidEmail(email) {const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; return emailRegex.test(email)}

    const [userData, setUserData] = useState(null)
    const [formData, setFormData] = useState({userName: '', userLastname: '', userPhone: '', roleId: '', userEmail: '', login: '', password: '', newPassword: '', enabled: ''})
    const [notification, setNotification] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        apiMy()
            .then(data => {
                if (data.code === 200) {
                    setUserData(data.data)
                    setFormData({
                        userName: data.data.userName || '',
                        userLastname: data.data.userLastname || '',
                        userPhone: data.data.userPhone || '',
                        roleId: data.data.roleId || '',
                        userEmail: data.data.userEmail || '',
                        login: data.data.login || '',
                        enabled: data.data.enabled || ''
                    })
                } else {
                    navigate('/login', {state: { from: location.pathname + location.search }})
                }
            })
            .catch(_ => {})
    }, [])

    const showNotification = (message, type = 'success') => {setNotification({ message, type })}
    const hideNotification = () => {setNotification(null)}

    const handleInputChange = (e) => {
        const { name, value } = e.target

        // Обработка телефона
        if (name === 'userPhone') {
            // Удаляем все нецифровые символы, кроме плюса в начале
            let cleanedValue = value.replace(/[^\d+]/g, '')

            // Если строка пустая или начинается с +, оставляем как есть
            if (cleanedValue === '' || cleanedValue.startsWith('+')) {
                // Удаляем все плюсы кроме первого
                const plusCount = (cleanedValue.match(/\+/g) || []).length
                if (plusCount > 1) {
                    cleanedValue = '+' + cleanedValue.replace(/\+/g, '')
                }

                // Ограничиваем длину до 13 символов (1 знак + и 12 цифр)
                if (cleanedValue.length > 13) {
                    cleanedValue = cleanedValue.substring(0, 13)
                }
            } else {
                // Если не начинается с +, добавляем его и ограничиваем цифры
                const digitsOnly = cleanedValue.replace(/\D/g, '')
                cleanedValue = '+' + digitsOnly.substring(0, 12)
            }

            setFormData(prev => ({...prev, [name]: cleanedValue}))
        } else {
            setFormData(prev => ({...prev, [name]: value}))
        }
    }

    const handleRoleChange = (value) => {
        setFormData(prev => ({...prev, roleId: value}))
    }

    const handleEnabledChange = (value) => {
        const boolValue = value === 'true'
        setFormData(prev => ({...prev, enabled: boolValue}))
    }

    const handleSave = () => {
        let forApiReq = {
            "userLogin": formData.login,
            "userPass": formData.password,

            "userName": formData.userName,
            "userLastname": formData.userLastname,
            "userPhone": formData.userPhone,
            "userEmail": formData.userEmail,

            "userRole": (formData.roleId === "" ? 7 : formData.roleId),
            "isActive": formData.enabled,
        }

        if (formData.userName === '') {showNotification('Не заполнено Имя', 'error')}
        else if (formData.userLastname === '') {showNotification('Не заполнена Фамилия', 'error')}
        else if (formData.userEmail === '') {showNotification('Не заполнен Email', 'error')}
        else if (!isValidEmail(formData.userEmail)) {showNotification('Введите корректный Email адрес', 'error')}
        else if (formData.userPhone === '') {showNotification('Не заполнен Телефон', 'error')}
        else if (formData.login === '') {showNotification('Не заполнен Логин', 'error')}
        else if (formData.password === '') {showNotification('Не заполнен Пароль', 'error')}
        else if (formData.newPassword === '') {showNotification('Не заполнен Повторный Пароль', 'error')}
        else if (formData.password !== formData.newPassword) {showNotification('Пароль и Повторный Пароль не совпадают', 'error')}
        else {
            apiUsersAdd(forApiReq)
                .then(data => {if (data.code === 200) {navigate('/panel/company/usersmanegment')} else {showNotification(data.data ?? 'Ошибка сохранения', 'error')}})
                .catch(_ => {showNotification('Ошибка сохранения', 'error')})
        }
    }

    // Функция для преобразования булева значения в строку для отображения в CustomSelect
    const getEnabledValueForDisplay = () => {
        if (typeof formData.enabled === 'boolean') {
            return formData.enabled ? 'true' : 'false'
        }
        return ''
    }

    if (!userData) {return <div className="loadersComponent"><Loaders/></div>}

    return (
        <div className="pageUserAdd">
            <Header/>
            <BreadCrumbs title={'Профиль компании → Пользователи → Добавить пользователя'} />
            <div className="pageUserAddContent">
                <div className="user-form-container">
                    <div className="form-grid">
                        {/* Левая колонка */}
                        <div className="form-column">
                            <div className="form-title">Общая информация</div>

                            <div className="form-field">
                                <label>Имя*</label>
                                <div>
                                    <input type="text" name="userName" value={formData.userName} onChange={handleInputChange}  placeholder="Не указано"/>
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Фамилия*</label>
                                <div>
                                    <input type="text" name="userLastname" value={formData.userLastname} onChange={handleInputChange}  placeholder="Не указано"/>
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Email*</label>
                                <div>
                                    <input type="text" name="userEmail" value={formData.userEmail} onChange={handleInputChange} placeholder="Не указано"/>
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Телефон*</label>
                                <div>
                                    <input type="text" name="userPhone" value={formData.userPhone} onChange={handleInputChange} placeholder="Не указано" maxLength={13}/>
                                </div>
                            </div>
                        </div>

                        {/* Правая колонка */}
                        <div className="form-column">
                            <div className="form-title">Учётные данные</div>

                            <div className="form-field">
                                <label>Роль*</label>
                                <div>
                                    <CustomSelect
                                        value={formData.roleId}
                                        options={[
                                            { roleId: '7', roleName: 'Администратор' },
                                            { roleId: '6', roleName: 'Менеджер' }
                                        ]}
                                        onChange={handleRoleChange}
                                        className="role-select"
                                        optionLabelKey="roleName"
                                        optionValueKey="roleId"
                                    />
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Логин*</label>
                                <div>
                                    <input type="text" name="login" value={formData.login} onChange={handleInputChange} placeholder="Не указано"/>
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Пароль*</label>
                                <div>
                                    <input type="text" name="password" value={formData.password} onChange={handleInputChange} placeholder="Не указано"/>
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Повторите пароль*</label>
                                <div>
                                    <input type="text" name="newPassword" value={formData.newPassword} onChange={handleInputChange} placeholder="Не указано"/>
                                </div>
                            </div>

                            <div className="form-field">
                                <label>Состояние*</label>
                                <div>
                                    <CustomSelect
                                        value={getEnabledValueForDisplay()}
                                        options={[
                                            { value: 'true', label: 'Активен' },
                                            { value: 'false', label: 'Не активен' }
                                        ]}
                                        onChange={handleEnabledChange}
                                        className="status-select"
                                        optionLabelKey="label"
                                        optionValueKey="value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Кнопки */}
                    <div className="allPagesStyleButton-posLeft">
                        <div className="allPagesStyleButton-group">
                            <div className="allPagesStyleButton" onClick={handleSave}>Сохранить</div>
                        </div>
                    </div>

                    {/* Уведомления */}
                    {notification && (
                        <Notification
                            message={notification.message}
                            type={notification.type}
                            onClose={hideNotification}
                            duration={3000}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default UserAdd

